// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/admin.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/admin.proto.
 */
export const file_api_proto_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("ChhhcGlfcHJvdG8vdjEvYWRtaW4ucHJvdG8SDGFwaV9wcm90by52MSJhChJHZXRBZG1pbk1lUmVzcG9uc2USCgoCaWQYASABKAMSDQoFZW1haWwYAiABKAkSDAoEbmFtZRgDIAEoCRIMCgRyb2xlGAQgASgJEhQKDGlzX2RldmVsb3BlchgFIAEoCCITChFHZXRBZG1pbk1lUmVxdWVzdCKBAQoFQWRtaW4SCgoCaWQYASABKAMSDQoFZW1haWwYAiABKAkSDAoEbmFtZRgDIAEoCRIrCgdjcmVhdGVkGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIMCgRyb2xlGAUgASgJEhQKDGlzX2RldmVsb3BlchgGIAEoCCITChFMaXN0QWRtaW5zUmVxdWVzdCI5ChJMaXN0QWRtaW5zUmVzcG9uc2USIwoGYWRtaW5zGAEgAygLMhMuYXBpX3Byb3RvLnYxLkFkbWluIiAKEkRlbGV0ZUFkbWluUmVxdWVzdBIKCgJpZBgBIAEoAyIjChJDcmVhdGVBZG1pblJlcXVlc3QSDQoFZW1haWwYASABKAkiOQoTQ3JlYXRlQWRtaW5SZXNwb25zZRIiCgVhZG1pbhgBIAEoCzITLmFwaV9wcm90by52MS5BZG1pbiI1ChNTZXRBZG1pblJvbGVSZXF1ZXN0EhAKCGFkbWluX2lkGAEgASgDEgwKBHJvbGUYAiABKAkiOgoUU2V0QWRtaW5Sb2xlUmVzcG9uc2USIgoFYWRtaW4YASABKAsyEy5hcGlfcHJvdG8udjEuQWRtaW4iQgoYU2V0QWRtaW5EZXZlbG9wZXJSZXF1ZXN0EhAKCGFkbWluX2lkGAEgASgDEhQKDGlzX2RldmVsb3BlchgCIAEoCCI/ChlTZXRBZG1pbkRldmVsb3BlclJlc3BvbnNlEiIKBWFkbWluGAEgASgLMhMuYXBpX3Byb3RvLnYxLkFkbWluQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Admin entity
 *
 * @generated from message api_proto.v1.GetAdminMeResponse
 */
export type GetAdminMeResponse = Message<"api_proto.v1.GetAdminMeResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 承認ワークフローでのロール general / approver / ceo（admins.role）。
   * 値の SSOT は go/models/admin_approval.go の AdminRole。
   * フロントは自分のロールで申請・承認・バイパスのボタンを出し分ける（サーバ側でも必ず再検査する）
   *
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * 開発者向け機能（Feature Flag画面・RPC）を使えるAdminかどうか（admins.is_developer）。
   * 承認ワークフローのroleとは独立した軸（承認者である開発者も、一般である開発者も居る）。
   * フロントは「開発者」メニュー・企業詳細の開発者タブの出し分けに使う
   * （サーバ側でもFeature Flag系RPCで必ず再検査する）
   *
   * @generated from field: bool is_developer = 5;
   */
  isDeveloper: boolean;
};

/**
 * Describes the message api_proto.v1.GetAdminMeResponse.
 * Use `create(GetAdminMeResponseSchema)` to create a new message.
 */
export const GetAdminMeResponseSchema: GenMessage<GetAdminMeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 0);

/**
 * @generated from message api_proto.v1.GetAdminMeRequest
 */
export type GetAdminMeRequest = Message<"api_proto.v1.GetAdminMeRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetAdminMeRequest.
 * Use `create(GetAdminMeRequestSchema)` to create a new message.
 */
export const GetAdminMeRequestSchema: GenMessage<GetAdminMeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 1);

/**
 * 管理者
 *
 * @generated from message api_proto.v1.Admin
 */
export type Admin = Message<"api_proto.v1.Admin"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 4;
   */
  created?: Timestamp;

  /**
   * general / approver / ceo（admins.role）
   *
   * @generated from field: string role = 5;
   */
  role: string;

  /**
   * 開発者向け機能を使えるAdminかどうか（admins.is_developer）。roleとは独立した軸
   *
   * @generated from field: bool is_developer = 6;
   */
  isDeveloper: boolean;
};

/**
 * Describes the message api_proto.v1.Admin.
 * Use `create(AdminSchema)` to create a new message.
 */
export const AdminSchema: GenMessage<Admin> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 2);

/**
 * 管理者一覧取得
 *
 * @generated from message api_proto.v1.ListAdminsRequest
 */
export type ListAdminsRequest = Message<"api_proto.v1.ListAdminsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListAdminsRequest.
 * Use `create(ListAdminsRequestSchema)` to create a new message.
 */
export const ListAdminsRequestSchema: GenMessage<ListAdminsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 3);

/**
 * @generated from message api_proto.v1.ListAdminsResponse
 */
export type ListAdminsResponse = Message<"api_proto.v1.ListAdminsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Admin admins = 1;
   */
  admins: Admin[];
};

/**
 * Describes the message api_proto.v1.ListAdminsResponse.
 * Use `create(ListAdminsResponseSchema)` to create a new message.
 */
export const ListAdminsResponseSchema: GenMessage<ListAdminsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 4);

/**
 * 管理者削除
 *
 * @generated from message api_proto.v1.DeleteAdminRequest
 */
export type DeleteAdminRequest = Message<"api_proto.v1.DeleteAdminRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteAdminRequest.
 * Use `create(DeleteAdminRequestSchema)` to create a new message.
 */
export const DeleteAdminRequestSchema: GenMessage<DeleteAdminRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 5);

/**
 * 管理者作成
 *
 * @generated from message api_proto.v1.CreateAdminRequest
 */
export type CreateAdminRequest = Message<"api_proto.v1.CreateAdminRequest"> & {
  /**
   * ログインに使用する email アドレス（必須）
   *
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message api_proto.v1.CreateAdminRequest.
 * Use `create(CreateAdminRequestSchema)` to create a new message.
 */
export const CreateAdminRequestSchema: GenMessage<CreateAdminRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 6);

/**
 * @generated from message api_proto.v1.CreateAdminResponse
 */
export type CreateAdminResponse = Message<"api_proto.v1.CreateAdminResponse"> & {
  /**
   * @generated from field: api_proto.v1.Admin admin = 1;
   */
  admin?: Admin;
};

/**
 * Describes the message api_proto.v1.CreateAdminResponse.
 * Use `create(CreateAdminResponseSchema)` to create a new message.
 */
export const CreateAdminResponseSchema: GenMessage<CreateAdminResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 7);

/**
 * 管理者ロールの変更（plan-restructure-2026-10 R6 tasks 6.4b）。
 * ceo のみ実行でき、自分自身の降格はできない（ceo が 0 人になり承認バイパスが不能になるため）
 *
 * @generated from message api_proto.v1.SetAdminRoleRequest
 */
export type SetAdminRoleRequest = Message<"api_proto.v1.SetAdminRoleRequest"> & {
  /**
   * @generated from field: int64 admin_id = 1;
   */
  adminId: bigint;

  /**
   * general / approver / ceo
   *
   * @generated from field: string role = 2;
   */
  role: string;
};

/**
 * Describes the message api_proto.v1.SetAdminRoleRequest.
 * Use `create(SetAdminRoleRequestSchema)` to create a new message.
 */
export const SetAdminRoleRequestSchema: GenMessage<SetAdminRoleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 8);

/**
 * @generated from message api_proto.v1.SetAdminRoleResponse
 */
export type SetAdminRoleResponse = Message<"api_proto.v1.SetAdminRoleResponse"> & {
  /**
   * @generated from field: api_proto.v1.Admin admin = 1;
   */
  admin?: Admin;
};

/**
 * Describes the message api_proto.v1.SetAdminRoleResponse.
 * Use `create(SetAdminRoleResponseSchema)` to create a new message.
 */
export const SetAdminRoleResponseSchema: GenMessage<SetAdminRoleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 9);

/**
 * 管理者の開発者フラグの変更（admin-ia-redesign-2026-09 §5.2）。
 * ceoのみ実行でき、自分自身の開発者フラグは変更できない（ロール変更と同じ規則）。
 * 承認ワークフローのroleとは独立した軸なので、roleとは別RPCにしてある
 *
 * @generated from message api_proto.v1.SetAdminDeveloperRequest
 */
export type SetAdminDeveloperRequest = Message<"api_proto.v1.SetAdminDeveloperRequest"> & {
  /**
   * @generated from field: int64 admin_id = 1;
   */
  adminId: bigint;

  /**
   * @generated from field: bool is_developer = 2;
   */
  isDeveloper: boolean;
};

/**
 * Describes the message api_proto.v1.SetAdminDeveloperRequest.
 * Use `create(SetAdminDeveloperRequestSchema)` to create a new message.
 */
export const SetAdminDeveloperRequestSchema: GenMessage<SetAdminDeveloperRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 10);

/**
 * @generated from message api_proto.v1.SetAdminDeveloperResponse
 */
export type SetAdminDeveloperResponse = Message<"api_proto.v1.SetAdminDeveloperResponse"> & {
  /**
   * @generated from field: api_proto.v1.Admin admin = 1;
   */
  admin?: Admin;
};

/**
 * Describes the message api_proto.v1.SetAdminDeveloperResponse.
 * Use `create(SetAdminDeveloperResponseSchema)` to create a new message.
 */
export const SetAdminDeveloperResponseSchema: GenMessage<SetAdminDeveloperResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin, 11);

